// extracted by mini-css-extract-plugin
export default {"seet":"SeatsCell_seet__L-7QN","court_title_flex":"SeatsCell_court_title_flex__kkaou","seets":"SeatsCell_seets__ri4rX"};